import Dropdown from "components/Dropdown";
import CommonTableModal from "modals/common/CommonTableModal";
import { useState } from "react";
import { MdDeleteForever } from "react-icons/md";
import { useNavigate, NavLink } from "react-router-dom";
import { selectedUser } from "redux/auth/authSlice";
import { useDispatch } from "react-redux";
import moment from "moment";

export const vehicleTableData = [
  {
    vehicleMake: "Rolls-Royce",
    vehicleModel: "Spectre",
    users: "10",
  },
  {
    vehicleMake: "Aiways",
    vehicleModel: "U6",
    users: "0",
  },
  {
    vehicleMake: "Rolls-Royce",
    vehicleModel: "Spectre",
    users: "10",
  },
];

export const chartColors = [
  { Users: "#228B22" },
  { Trips: "#2E49B8" },
  { Vehicle: "#FFB800" },
];

// **************Organizations  Data ***************//

export const ORGANIZATIONSCOLUMNS = [
  {
    Header: "Org Name",
    accessor: "org_name",
    Cell: ({ value }) => (
      <NavLink to={`/organizations/${value}`}>{value}</NavLink>
    ),
  },
  {
    Header: "Admin Name",
    accessor: "admin_Name",
  },
  {
    Header: "Vehicle",
    accessor: "vehicle",
    Cell: ({ value }) => {
      return (
        <div className="flex items-center gap-1">
          {value}
          {value > 0 && (
            <>
              <span className="w-1 h-1 bg-ezLightBlue inline-flex rounded-lg "></span>
              <NavLink
                className="text-ezGreen cursor-pointer"
                to={`/organizations/organization-vehicle/${value.id}`}
              >
                view
              </NavLink>
            </>
          )}
        </div>
      );
    },
  },
  {
    Header: "Employees",
    accessor: "employees",
    Cell: ({ value }) => {
      return (
        <div className="flex items-center gap-1">
          {value}
          {value > 0 && (
            <>
              <span className="w-1 h-1 bg-ezLightBlue inline-flex rounded-lg "></span>
              <NavLink
                className="text-ezGreen cursor-pointer"
                to={`/organizations/organization-all-users/${value.id}`}
              >
                view
              </NavLink>
            </>
          )}
        </div>
      );
    },
  },
  {
    Header: "Trips",
    accessor: "trips",
    Cell: ({ value }) => {
      return (
        <div className="flex items-center gap-1">
          {value}
          {value > 0 && (
            <>
              <span className="w-1 h-1 bg-ezLightBlue inline-flex rounded-lg "></span>
              <NavLink
                className="text-ezGreen cursor-pointer"
                to={`/organizations/organization-trips/${value.id}`}
              >
                view
              </NavLink>
            </>
          )}
        </div>
      );
    },
  },

  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Actions",
    accessor: "actions",
    Cell: () => <Dropdown icon />,
  },
];

export const ORGANIZATIONSDATA = [
  {
    org_name: "Geotab",
    admin_Name: "John Victor",
    trips: "0",
    employees: "5",
    vehicle: "3",
    status: "Pending",
  },
  {
    org_name: "Fleet Complete",
    admin_Name: "Candice Wu",
    trips: "10",
    employees: "0",
    vehicle: "9",
    status: "Accept",
  },
  {
    org_name: "Geotab",
    admin_Name: "John Victor",
    trips: "0",
    employees: "5",
    vehicle: "0",
    status: "Pending",
  },
  {
    org_name: "Geotab",
    admin_Name: "John Victor",
    trips: "0",
    employees: "5",
    vehicle: "3",
    status: "Pending",
  },
  {
    org_name: "Fleet Complete",
    admin_Name: "Candice Wu",
    trips: "10",
    employees: "0",
    vehicle: "9",
    status: "Accept",
  },
  {
    org_name: "Geotab",
    admin_Name: "John Victor",
    trips: "0",
    employees: "5",
    vehicle: "0",
    status: "Pending",
  },
  {
    org_name: "Geotab",
    admin_Name: "John Victor",
    trips: "0",
    employees: "5",
    vehicle: "3",
    status: "Pending",
  },
  {
    org_name: "Fleet Complete",
    admin_Name: "Candice Wu",
    trips: "10",
    employees: "0",
    vehicle: "9",
    status: "Accept",
  },
  {
    org_name: "Geotab",
    admin_Name: "John Victor",
    trips: "0",
    employees: "5",
    vehicle: "0",
    status: "Pending",
  },
  {
    org_name: "Geotab",
    admin_Name: "John Victor",
    trips: "0",
    employees: "5",
    vehicle: "3",
    status: "Pending",
  },
  {
    org_name: "Fleet Complete",
    admin_Name: "Candice Wu",
    trips: "10",
    employees: "0",
    vehicle: "9",
    status: "Accept",
  },
  {
    org_name: "Geotab",
    admin_Name: "John Victor",
    trips: "0",
    employees: "5",
    vehicle: "0",
    status: "Pending",
  },
];

export const ORGTRIPSCOLUMNS = [
  {
    Header: "Trip ID",
    accessor: "tripId",
    Cell: ({ value }) => <NavLink to={`/trips/${value}`}>{value}</NavLink>,
  },
  {
    Header: "User Name",
    accessor: "user_Name",
  },
  {
    Header: "User Email",
    accessor: "user_Email",
  },

  {
    Header: "Route",
    accessor: "route",
  },
  {
    Header: "Vehicle",
    accessor: "vehicle",
  },
  {
    Header: "Status",
    accessor: "status",
  },
];

// **************Organizations Trips Data ***************//

export const ORGTRIPSDATA = [
  {
    tripId: 56468,
    user_Name: "Torie",
    user_Email: "Rustman@gmail.com",
    route: "Trip to Florida, USA",
    vehicle: "Rolls-Royce. spectre, 200",
    status: "In Progress",
  },
  {
    tripId: 256468,
    user_Name: "Torie",
    user_Email: "Rustman@gmail.com",
    route: "Trip to Florida, USA",
    vehicle: "Rolls-Royce. spectre, 200",
    status: "Completed",
  },
];

// **************Organizations Trips Data ***************//

export const ORG_USERS_COLUMNS = [
  {
    Header: "Full Name",
    accessor: "full_Name",
    Cell: ({ value }) => <NavLink to={`/trips/${value}`}>{value}</NavLink>,
  },
  {
    Header: "User Email",
    accessor: "user_Email",
  },
  {
    Header: "Vehicle Make",
    accessor: "vehicle_Make",
  },
  {
    Header: "Total Trips",
    accessor: "total_Trips",
    Cell: ({ value }) => {
      const [modalOpen, setModalOpen] = useState(false);

      const handleViewClick = () => {
        setModalOpen(true);
      };

      return (
        <div className="flex items-center gap-1">
          {value}
          <span className="w-1 h-1 bg-ezLightBlue inline-flex rounded-lg "></span>
          <p className="text-ezGreen cursor-pointer" onClick={handleViewClick}>
            view
          </p>
          {modalOpen && (
            <CommonTableModal
              isViewModal={modalOpen}
              setIsViewModal={setModalOpen}
              ModalHeader="Trips"
              column={TRIPSCOLUMNS}
              row={TRIPSDATA}
            />
          )}
        </div>
      );
    },
  },
  {
    Header: "City",
    accessor: "city",
  },

  {
    Header: "State",
    accessor: "state",
  },
  {
    Header: "Country",
    accessor: "country",
  },
  {
    Header: "Zip",
    accessor: "zip",
  },
  {
    Header: "Actions",
    accessor: "actions",
    Cell: () => <Dropdown icon />,
  },
];

export const ORG_USERS_DATA = [
  {
    full_Name: "Torie",
    vehicle_Make: "Rolls-Royce. spectre",
    user_Email: "Rustman@gmail.com",
    total_Trips: "5",
    city: "Fort Myers",
    state: "Florida",
    country: "United States",
    zip: "33901",
  },
  {
    full_Name: "CandiceWu",
    vehicle_Make: "Rolls-Royce. spectre",
    user_Email: "CandiceWu@gmail.com",
    total_Trips: "5",
    city: "Fort Myers",
    state: "Florida",
    country: "United States",
    zip: "33901",
  },
];
// **************Trips Data ***************//

export const TRIPSCOLUMNS = [
  // {
  //   Header: "ID",
  //   accessor: "_id",
  // },
  {
    Header: "From",
    accessor: "origin.text",
    Cell: ({ value }) => value?.length > 25 ? value.substring(0, 25) + '...' : value,
  },
  {
    Header: "To",
    accessor: "destination.text",
    Cell: ({ value }) => value?.length > 25 ? value.substring(0, 15) + '...' : value,
  },
  {
    Header: "Distance",
    accessor: "distance",
  },
  {
    Header: "Start Date",
    accessor: "startDate",
    Cell: ({ value }) =>
      value ? moment(new Date(value)).format("MM/DD/YYYY") : "",
  },
  {
    Header: "Status",
    accessor: "status",
    Cell: ({ value }) => {
      return (
        <span
          className={`inline-flex capitalize items-center rounded-full ${
            value === "completed"
              ? "bg-completed text-completed"
              : value === "inprogress"
              ? "bg-inprogress text-inprogress"
              : value === "cancelled"
              ? "bg-cancelled text-cancelled"
              : value === "upcoming"
              ? "bg-upcoming text-upcoming"
              : "bg-ezGray text-ezGray"
          } bg-opacity-20 px-2 py-1 text-xs font-medium `}
        >
          {value === "inprogress"
            ? "In Progress"
            : value === "upcoming"
            ? "Upcoming"
            : value === "notStarted"
            ? "Not Started"
            : value === "cancelled"
            ? "Cancelled"
            : value}
        </span>
      );
    },
  },
  {
    Header: "Actions",
    accessor: "_id",
    Cell: ({value}) => {
      const navigate = useNavigate();
      return (
        <button onClick={()=>navigate(`/trips/${value}`)} className="flex justify-center w-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-5 h-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
            />
          </svg>
        </button>
      );
    },
  },
];

export const TRIPSDATA = [
  {
    tripId: 56468,
    user_Name: "Torie",
    org_name: "Rustman",
    route: "Trip to Florida, USA",
    vehicle: "Rolls-Royce. spectre, 200",
    status: "In Progress",
  },
  {
    tripId: 256468,
    user_Name: "Torie",
    org_name: "Rustman",
    route: "Trip to Florida, USA",
    vehicle: "Rolls-Royce. spectre, 200",
    status: "Completed",
  },
  {
    tripId: 56468,
    user_Name: "Torie",
    org_name: "Rustman",
    route: "Trip to Florida, USA",
    vehicle: "Rolls-Royce. spectre, 200",
    status: "In Progress",
  },
  {
    tripId: 256468,
    user_Name: "Torie",
    org_name: "Rustman",
    route: "Trip to Florida, USA",
    vehicle: "Rolls-Royce. spectre, 200",
    status: "Completed",
  },
  {
    tripId: 56468,
    user_Name: "Torie",
    org_name: "Rustman",
    route: "Trip to Florida, USA",
    vehicle: "Rolls-Royce. spectre, 200",
    status: "In Progress",
  },
  {
    tripId: 256468,
    user_Name: "Torie",
    org_name: "Rustman",
    route: "Trip to Florida, USA",
    vehicle: "Rolls-Royce. spectre, 200",
    status: "Completed",
  },
  {
    tripId: 56468,
    user_Name: "Torie",
    org_name: "Rustman",
    route: "Trip to Florida, USA",
    vehicle: "Rolls-Royce. spectre, 200",
    status: "In Progress",
  },
  {
    tripId: 256468,
    user_Name: "Torie",
    org_name: "Rustman",
    route: "Trip to Florida, USA",
    vehicle: "Rolls-Royce. spectre, 200",
    status: "Completed",
  },
  {
    tripId: 56468,
    user_Name: "Torie",
    org_name: "Rustman",
    route: "Trip to Florida, USA",
    vehicle: "Rolls-Royce. spectre, 200",
    status: "In Progress",
  },
  {
    tripId: 256468,
    user_Name: "Torie",
    org_name: "Rustman",
    route: "Trip to Florida, USA",
    vehicle: "Rolls-Royce. spectre, 200",
    status: "Completed",
  },
];

export const ORG_VEHICLE_COLUMNS = [
  {
    Header: "Vehicle Make",
    accessor: "vehicle_Make",
    Cell: ({ value }) => <NavLink to={`/trips/${value}`}>{value}</NavLink>,
  },
  {
    Header: "Vehicle Model",
    accessor: "vehicle_Model",
  },
  {
    Header: "Drivers",
    accessor: "drivers",
    Cell: ({ value }) => {
      const [modalOpen, setModalOpen] = useState(false);

      const handleViewClick = () => {
        setModalOpen(true);
      };

      return (
        <div className="flex items-center gap-1">
          {value}
          <span className="w-1 h-1 bg-ezLightBlue inline-flex rounded-lg "></span>
          <p className="text-ezGreen cursor-pointer" onClick={handleViewClick}>
            view
          </p>
          {modalOpen && (
            <CommonTableModal
              isViewModal={modalOpen}
              setIsViewModal={setModalOpen}
              ModalHeader="Users"
              column={ORG_VEHICLE_DRIVERS_MODAL_COLUMNS}
              row={ORG_VEHICLE_DRIVERS_MODAL_DATA}
            />
          )}
        </div>
      );
    },
  },

  {
    Header: "Total Trips",
    accessor: "totalTrips",
    Cell: ({ value }) => {
      const [modalOpen, setModalOpen] = useState(false);

      const handleViewClick = () => {
        setModalOpen(true);
      };

      return (
        <div className="flex items-center gap-1">
          {value}
          <span className="w-1 h-1 bg-ezLightBlue inline-flex rounded-lg "></span>
          <p className="text-ezGreen cursor-pointer" onClick={handleViewClick}>
            view
          </p>
          {modalOpen && (
            <CommonTableModal
              isViewModal={modalOpen}
              setIsViewModal={setModalOpen}
              ModalHeader="Trips"
              column={TRIPSCOLUMNS}
              row={TRIPSDATA}
            />
          )}
        </div>
      );
    },
  },

  {
    Header: "Actions",
    accessor: "actions",
    Cell: () => <Dropdown icon />,
  },
];

export const ORG_VEHICLE_DATA = [
  {
    vehicle_Make: "Rolls-Royce",
    vehicle_Model: "spectre",
    totalTrips: 5,
    drivers: 3,
  },
  {
    vehicle_Make: "Rolls-Royce",
    vehicle_Model: "spectre",
    totalTrips: 5,
    drivers: 3,
  },
  {
    vehicle_Make: "Rolls-Royce",
    vehicle_Model: "spectre",
    totalTrips: 5,
    drivers: 3,
  },
  {
    vehicle_Make: "Rolls-Royce",
    vehicle_Model: "spectre",
    totalTrips: 5,
    drivers: 3,
  },
  {
    vehicle_Make: "Rolls-Royce",
    vehicle_Model: "spectre",
    totalTrips: 5,
    drivers: 3,
  },
  {
    vehicle_Make: "Rolls-Royce",
    vehicle_Model: "spectre",
    totalTrips: 5,
    drivers: 3,
  },
  {
    vehicle_Make: "Rolls-Royce",
    vehicle_Model: "spectre",
    totalTrips: 5,
    drivers: 3,
  },
];

export const ORG_VEHICLE_DRIVERS_MODAL_COLUMNS = [
  {
    Header: 'User Name',
    accessor: 'userId.name',
    Cell: ({ value }) => value || 'unknown',
  },
  {
    Header: 'User Email',
    accessor: 'userId.email',
    Cell: ({ value }) => value || 'unknown',
  },
  // {
  //   Header: 'Actions',
  //   accessor: 'actions',
  //   Cell: () => (
  //     <MdDeleteForever className='w-6 h-6 text-ezRed hover:cursor-pointer' />
  //   ),
  // },
];

export const ORG_VEHICLE_DRIVERS_MODAL_DATA = [
  {
    user_Name: "John Victor",
    user_Email: "john@gmail.com",
  },
];

export const USERS_COLUMNS = [
  {
    Header: "Full Name",
    accessor: "name",
    Cell: ({ row }) => {
      const dispatch = useDispatch();

      return (
        <NavLink
          onClick={() => dispatch(selectedUser(row?.original))}
          to={`/users/${row?.original?._id}`}
        >
          {row?.original?.name}
        </NavLink>
      );
    },
  },
  {
    Header: "User Email",
    accessor: "email",
  },
  {
    Header: "Phone Number",
    accessor: "phone",
  },
  // {
  //   Header: 'Org Name',
  //   accessor: 'org_Name',
  // },
  {
    Header: "Vehicles",
    accessor: "vehicles",
    // Cell: ({ value }) => {
    //   const [modalOpen, setModalOpen] = useState(false);

    //   const handleViewClick = () => {
    //     setModalOpen(true);
    //   };

    //   return (
    //     <div className='flex items-center gap-1'>
    //       {value}
    //       <span className='w-1 h-1 bg-ezLightBlue inline-flex rounded-lg '></span>
    //       <p className='text-ezGreen cursor-pointer' onClick={handleViewClick}>
    //         view
    //       </p>
    //       {modalOpen && (
    //         <CommonTableModal isViewModal={modalOpen} setIsViewModal={setModalOpen}
    //           ModalHeader='Vehicle' column={USERS_VEHICLE_COLUMNS} row={ORG_VEHICLE_DATA} />
    //       )}
    //     </div>
    //   );
    // }
  },
  {
    Header: "Trips",
    accessor: "trips",
    // Cell: ({ value }) => {
    //   const [modalOpen, setModalOpen] = useState(false);

    //   const handleViewClick = () => {
    //     setModalOpen(true);
    //   };

    //   return (
    //     <div className='flex items-center gap-1'>
    //       {value}
    //       <span className='w-1 h-1 bg-ezLightBlue inline-flex rounded-lg '></span>
    //       <p className='text-ezGreen cursor-pointer' onClick={handleViewClick}>
    //         view
    //       </p>
    //       {modalOpen && (
    //         <CommonTableModal isViewModal={modalOpen} setIsViewModal={setModalOpen}
    //           ModalHeader='Trips' column={USERS_TRIPSCOLUMNS} row={TRIPSDATA} />
    //       )}
    //     </div>
    //   );
    // }
  },

  // {
  //   Header: 'State',
  //   accessor: 'state',

  // },
  // {
  //   Header: 'Country',
  //   accessor: 'country',

  // },
  // {
  //   Header: 'Zip',
  //   accessor: 'zip'
  // },
  // {
  //   Header: 'Actions',
  //   accessor: '_id',
  //   Cell: ({ value }) =>
  //   (
  //     <>
  //       <Dropdown icon />
  //     </>
  //   )

  // },
];

export const USERS_DATA = [
  {
    full_Name: "Torie",
    user_Email: "Rustman@gmail.com",
    org_Name: "Geotab",
    vehicle: 2,
    trips: "5",
    city: "Fort Myers",
    state: "Florida",
    country: "United States",
    zip: "33901",
  },
  {
    full_Name: "Torie",
    user_Email: "Rustman@gmail.com",
    org_Name: "Geotab",
    vehicle: 4,
    trips: "5",
    city: "Fort Myers",
    state: "Florida",
    country: "United States",
    zip: "33901",
  },
];

export const USERS_TRIPSCOLUMNS = [
  {
    Header: "Trip ID",
    accessor: "tripId",
    Cell: ({ value }) => <NavLink to={`/trips/${value}`}>{value}</NavLink>,
  },

  {
    Header: "Route",
    accessor: "route",
  },
  {
    Header: "Vehicle",
    accessor: "vehicle",
  },
  {
    Header: "Status",
    accessor: "status",
  },
];

export const USERS_VEHICLE_COLUMNS = [
  {
    Header: "Vehicle Make",
    accessor: "vehicle_Make",
    Cell: ({ value }) => <NavLink to={`/trips/${value}`}>{value}</NavLink>,
  },
  {
    Header: "Vehicle Model",
    accessor: "vehicle_Model",
  },
];

export const VEHICLE_COLUMNS = [
  {
    Header: 'Vehicle Make',
    accessor: 'make.name',
    // Cell: ({ row }) => (
    //   <NavLink to={`/vehicles/${row.original._id}`}>
    //     {row.original.make.name}
    //   </NavLink>
    // ),
  },
  {
    Header: 'Vehicle Model',
    accessor: 'model.model',
  },
  {
    Header: 'Users',
    accessor: 'users',
    Cell: ({ value }) => {
      const [modalOpen, setModalOpen] = useState(false);

      const handleViewClick = () => {
        setModalOpen(true);
      };

      return (
        <div className="flex items-center gap-1">
          {value?.length}
          <span className="w-1 h-1 bg-ezLightBlue inline-flex rounded-lg "></span>
          <p className="text-ezGreen cursor-pointer" onClick={handleViewClick}>
            view
          </p>
          {modalOpen && (
            <CommonTableModal
              isViewModal={modalOpen}
              setIsViewModal={setModalOpen}
              ModalHeader="Users"
              column={ORG_VEHICLE_DRIVERS_MODAL_COLUMNS}
              row={value}
            />
          )}
        </div>
      );
    },
  },
];

export const VEHICLE_DATA = [
  {
    vehicle_Make: "Rolls-Royce",
    vehicle_Model: "spectre",
    users: 5,
  },
];

export const ACTIVITIES_COLUMNS = [
  {
    Header: "Tracking ID",
    accessor: "trackingId",
    Cell: ({ value }) => (
      <NavLink to={`/charging-activities/${value}`}>{value}</NavLink>
    ),
  },
  {
    Header: "User Name",
    accessor: "user_Name",
  },
  {
    Header: "Org Name",
    accessor: "org_Name",
  },
  {
    Header: "Connector Name",
    accessor: "connector_Name",
  },
  {
    Header: "Station Address",
    accessor: "station_Address",
  },
  {
    Header: "Vehicle Make, Model",
    accessor: "vehicle",
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Actions",
    accessor: "actions",
    Cell: () => <Dropdown icon />,
  },
];

export const ACTIVITIES_DATA = [
  {
    trackingId: 654214,
    user_Name: "Demi Wilkinson",
    org_Name: "Fleetio",
    connector_Name: "EZVOLTZON001",
    station_Address: "Trip to Florida, USA",
    vehicle: "Dacia, Spring Electric 45",
    status: "Charging",
  },
  {
    trackingId: 654214,
    user_Name: "Demi Wilkinson",
    org_Name: "Fleetio",
    connector_Name: "EZVOLTZON001",
    station_Address: "Trip to Florida, USA",
    vehicle: "Dacia, Spring Electric 45",
    status: "Charging",
  },
  {
    trackingId: 654214,
    user_Name: "Demi Wilkinson",
    org_Name: "Fleetio",
    connector_Name: "EZVOLTZON001",
    station_Address: "Trip to Florida, USA",
    vehicle: "Dacia, Spring Electric 45",
    status: "Charging",
  },
  {
    trackingId: 654214,
    user_Name: "Demi Wilkinson",
    org_Name: "Fleetio",
    connector_Name: "EZVOLTZON001",
    station_Address: "Trip to Florida, USA",
    vehicle: "Dacia, Spring Electric 45",
    status: "Charging",
  },
  {
    trackingId: 654214,
    user_Name: "Demi Wilkinson",
    org_Name: "Fleetio",
    connector_Name: "EZVOLTZON001",
    station_Address: "Trip to Florida, USA",
    vehicle: "Dacia, Spring Electric 45",
    status: "Charging",
  },

  {
    trackingId: 654214,
    user_Name: "Demi Wilkinson",
    org_Name: "Fleetio",
    connector_Name: "EZVOLTZON001",
    station_Address: "Trip to Florida, USA",
    vehicle: "Dacia, Spring Electric 45",
    status: "Charging",
  },
];

export const USER_DETAIL_VEHICLE_COLUMNS = [
  {
    Header: "Vehicle ID",
    accessor: "_id",
  },
  {
    Header: "Vehicle Make",
    accessor: "make.name",
    Cell: ({ value }) => <NavLink to={`/trips/${value}`}>{value}</NavLink>,
  },
  {
    Header: "Vehicle Model",
    accessor: "model.model",
  },
  {
    Header: "Trips",
    accessor: "trips",
  },
];

export const USER_DETAIL_VEHICLE_DATA = [
  {
    vehicle_Make: "Rolls-Royce",
    vehicle_Model: "spectre",
    trips: 5,
    plate_Number: "ABCDKHSD",
  },
  {
    vehicle_Make: "Rolls-Royce",
    vehicle_Model: "spectre",
    trips: 5,
    plate_Number: "ABCDKHSD",
  },
  {
    vehicle_Make: "Rolls-Royce",
    vehicle_Model: "spectre",
    trips: 5,
    plate_Number: "ABCDKHSD",
  },
  {
    vehicle_Make: "Rolls-Royce",
    vehicle_Model: "spectre",
    trips: 5,
    plate_Number: "ABCDKHSD",
  },
  {
    vehicle_Make: "Rolls-Royce",
    vehicle_Model: "spectre",
    trips: 5,
    plate_Number: "ABCDKHSD",
  },
];

export const USER_DETAIL_TRIPS_COLUMNS = [
  {
    Header: "Trip ID",
    accessor: "_id",
  },
  {
    Header: "From",
    accessor: "destination.text",
  },
  {
    Header: "To",
    accessor: "origin.text",
  },
  {
    Header: "Start Date",
    accessor: "startDate",
    Cell: ({ value }) => (value ? new Date(value).toLocaleDateString() : ""),
  },
  {
    Header: "Status",
    accessor: "status",
    Cell: ({ value }) => {
      return (
        <span
          className={`inline-flex capitalize items-center rounded-full ${
            value === "completed"
              ? "bg-completed text-completed"
              : value === "inprogress"
              ? "bg-inprogress text-inprogress"
              : value === "cancelled"
              ? "bg-cancelled text-cancelled"
              : value === "upcoming"
              ? "bg-upcoming text-upcoming"
              : "bg-ezGray text-ezGray"
          } bg-opacity-20 px-2 py-1 text-xs font-medium `}
        >
          {value === "inprogress"
            ? "In Progress"
            : value === "upcoming"
            ? "Upcoming"
            : value === "notStarted"
            ? "Not Started"
            : value}
        </span>
      );
    },
  },
];

export const VEHICLE_DETAIL_USERS_COLUMNS = [
  {
    Header: "Full Name",
    accessor: "full_Name",
  },
  {
    Header: "User Email",
    accessor: "user_Email",
  },

  {
    Header: "Trips",
    accessor: "trips",
    Cell: ({ value }) => {
      const [modalOpen, setModalOpen] = useState(false);

      const handleViewClick = () => {
        setModalOpen(true);
      };

      return (
        <div className="flex items-center gap-1">
          {value}
          <span className="w-1 h-1 bg-ezLightBlue inline-flex rounded-lg "></span>
          <p className="text-ezGreen cursor-pointer" onClick={handleViewClick}>
            view
          </p>
          {modalOpen && (
            <CommonTableModal
              isViewModal={modalOpen}
              setIsViewModal={setModalOpen}
              ModalHeader="Trips"
              column={USERS_TRIPSCOLUMNS}
              row={TRIPSDATA}
            />
          )}
        </div>
      );
    },
  },
  {
    Header: "City",
    accessor: "city",
  },

  {
    Header: "State",
    accessor: "state",
  },
  {
    Header: "Country",
    accessor: "country",
  },
  {
    Header: "Zip",
    accessor: "zip",
  },
  {
    Header: "Actions",
    accessor: "actions",
    Cell: () => <MdDeleteForever className="w-8 h-8 text-ezRed" />,
  },
];

export const PAYMENT_COLUMNS = [
  {
    Header: "Type",
    accessor: "type",
  },

  {
    Header: "Card Number",
    accessor: "card_Number",
    Cell: ({ value }) => {
      const hiddenDigits =
        value.slice(0, 5) +
        " " +
        "*".repeat(4) +
        " " +
        "*".repeat(4) +
        " " +
        value.slice(14);
      return <span>{hiddenDigits}</span>;
    },
  },
  {
    Header: "Card Holder",
    accessor: "card_Holder",
  },
  {
    Header: "Assigned User",
    accessor: "assigned_User",
    Cell: ({ value }) => {
      const [modalOpen, setModalOpen] = useState(false);

      const handleViewClick = () => {
        setModalOpen(true);
      };

      return (
        <div className="flex items-center gap-1">
          {value}
          <span className="w-1 h-1 bg-ezLightBlue inline-flex rounded-lg "></span>
          <p className="text-ezGreen cursor-pointer" onClick={handleViewClick}>
            view
          </p>
          {modalOpen && (
            <CommonTableModal
              isViewModal={modalOpen}
              setIsViewModal={setModalOpen}
              ModalHeader="Users"
              column={ORG_VEHICLE_DRIVERS_MODAL_COLUMNS}
              row={ORG_VEHICLE_DRIVERS_MODAL_DATA}
            />
          )}
        </div>
      );
    },
  },
  {
    Header: "Actions",
    accessor: "actions",
    Cell: () => <Dropdown icon />,
  },
];

export const PAYMENT_DATA = [
  {
    type: "Visa",
    card_Number: "1354 1234 3456 8132",
    card_Holder: "Waqas",
    assigned_User: 10,
  },
];
